// Vuetify
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

//import fcLight from './themes/fc-light';
import fabled from './themes/fabled';
import 'vuetify/styles';

import { fa } from 'vuetify/iconsets/fa';
import { mdi } from 'vuetify/iconsets/mdi';

export const vuetify = createVuetify({
    components,
    directives,
    styles: {
        configFile: 'src/css/settings.scss',
    },
    display: {
        mobileBreakpoint: 'sm',
        //Match TailwindCSS
        thresholds: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            '2xl': 1536
        },
    },
    icons: {
        defaultSet: 'mdi', // 'mdiSvg' || 'faSvg'
        sets: {
            fa,
            mdi,
        }
    },
    theme: {
        defaultTheme: 'fabled',
        themes: {
            fabled,
        },
    },
    defaults: {
        VAutocomplete: {
            color: 'primary',
        },
        VCheckbox: {
            color: 'primary',
        },
        VDatePicker: {
            color: 'accent',
        },
        VFileInput: {
            color: 'primary',
        },
        VRadio: {
            color: 'primary',
        },
        VSwitch: {
            color: 'primary',
        },
        VTextarea: {
            color: 'primary',
        },
        VTextField: {
            color: 'primary',
        },
        VSelect: {
            color: 'primary',
        },
        VBtn: {
            color: 'primary',
        },
        VIcon: {
            color: 'accent',
        },
    },
});
